module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-11-23 at 3.08.10 PM.fdbd6441.png";